export default {
  base: {
    funKey: 'base',
    name: '基础',
    apis: [{
      path: '/basis/worker/batch',
      method: 'POST'
    }]
  }
}